import { Unit } from '../../../shared/common/units';

export interface UnitsAdaptee {
  standardizeUnit(unit: Unit | string): string;
}

export enum UnitsAdapterType {
  Default = 'DefaultUnitsAdapter',
  RemoteService = 'RemoteServiceUnitsAdapter',
  Trending = 'Trending',
  Hems = 'HemsUnitsAdapter',
  Consumption = 'ConsumptionChartsUnitsAdapter',
}

export enum RemoteServiceUnitType {
  Percentage = 'percentage',
  Percent = 'percent',
  Celcius = 'degree_celcius',
  Celsius = 'degree_celsius',
  Fahrenheit = 'fahrenheit_celsius',
  DecibelMilliwat = 'decibel_milliwatt',
  Bar = 'bar',
  LiterPerHour = 'liter_per_hour',
  Number = 'number',
  PercentageMinutePerKelvin = 'percentage_minute_per_kelvin',
  Minute = 'minute',
  Hour = 'hour',
  KiloWattHours = 'kilo_watt_hours',
  Watt = 'watt',
  Kelvin = 'kelvin',
  Correlation = 'correlation',
  StartsPerHour = 'starts_per_hour',
  Ratio = 'ratio',
  Boolean = 'boolean',
  NoUnit = 'nounit',
}

export enum TrendingUnitType {
  LitersPerHour = 'l/h',
  Celsius = '°C',
  Percent = '%',
}
